import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AutoCompleteService, UserService, ReportService } from '../../_services';
import { Observable, Subject } from 'rxjs';
import { Supplier, EnterVoWD, LoginUser, CostCenter, MstCompliance, Role } from '../../_models';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { GlobalDataService } from '../../_shared';
import { environment } from '../../../environments/environment';
import { AdminService } from '../../_services/admin.service';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';

@Component({
  selector: 'app-add-vowd',
  templateUrl: './add-vowd.component.html',
  styleUrls: ['./add-vowd.component.css']
})
export class AddVowdComponent implements OnInit {
 //Auto complete declartion
 results!: Observable<Supplier[]>;  
private searchTerms = new Subject<string>();  
 resultsCC!: Observable<CostCenter[]>;  
private searchTermsCC = new Subject<string>();  
 resultsObj!: Observable<string[]>; 
private searchTermsObj = new Subject<string>();  
 SupNo!: Number;
 SupName = '';  
 SupShortName : string|undefined;  
 loading: boolean = true;
  lstCostCenter!: CostCenter[];
  suppliersResult!: Supplier[];
  exceptionSupplierResult!: Supplier[];
  lstAccount!: string[];
  lstContract!: string[];
  ContractIdentity!: Number;
SelectedCC: any = "";
SelectedContract: any = "";
prevSelectedContract: any = "";
CompanyCode :any ="";
AreaModel :any ="";
DepartmentModel : any="";
SelectedAcnt :any ="";
ObjectAccountDesr :any ="";
SelectedCur :any ="";
 MonthYear!: string;
 Vowd!: EnterVoWD;
  DivisionField!: String;
  VOWDAmount!: Number;
  PreviousContractVOWDAmount!: Number;
  ContractVOWDAmount!: number;
  DescriptionofWork!: String;
 ModalHeader!: String;
  lstCurrency!: any[];
  user!: LoginUser;
  mstCompliances!: MstCompliance[];
  dueDate!: Date;
 BehalfCAI!: string;
 EnterCAI!: string;
  arrayList!: Array<string>;
  ExceptionSupplierList!: Array<string>;
  arrayListCostCntr!: Array<string>;
checkDuplicate :any;
checkobjaccount :any;
  prevSupNo!: Number;
  prevSelectedCC!: string;
  prevSelectedAcnt!: string;
constructor(private gd :GlobalDataService,  private activeModal: NgbActiveModal,private autoCompleteService  : AutoCompleteService,private userService : UserService , private adminService  : AdminService,  private reportService  : ReportService,    private modalService: NgbModal,) { }

  ngOnInit() {
    this.getSuppliers();
    this.getCostCenterList();
    this.getObjectAccount(); 
    this.user = this.gd.getUserData();
    if(this.mstCompliances ==null)
      this.getAllMstComp();
    if(this.Vowd !=null)
      this.initForm();
  }
   
  initForm()

  {
    this.SupNo = this.Vowd.SupplierAB;
    this.prevSupNo = this.Vowd.SupplierAB;
    this.SupName =this.Vowd.SupplierAB +"-" +this.Vowd.MstSupplier?.SupplierName ;
    this.SupShortName =this.Vowd.MstSupplier?.SupplierShortName;
    this.SelectedCC = this.Vowd.CostCenter.trim();    
    this.prevSelectedCC = this.Vowd.CostCenter.trim();
    this.getContractData(this.SupNo.toString());
    this.prevSelectedContract = this.Vowd.ContractId == null || this.Vowd.ContractDecscription.trim() == "" ? '' : this.Vowd.ContractId.trim()+"-"+this.Vowd.ContractDecscription.trim();
    this.SelectedContract = this.Vowd.ContractId == null || this.Vowd.ContractDecscription.trim() == "" ? '' : this.Vowd.ContractId.trim()+"-"+this.Vowd.ContractDecscription.trim();
    this.CompanyCode = this.Vowd.MstCostCenter?.CompanyCode.trim();
    this.AreaModel = this.Vowd.MstCostCenter?.Area_CODE.trim()+"-" +this.Vowd.MstCostCenter?.Area_description.trim();
    this.DepartmentModel = this.Vowd.MstCostCenter?.Division.trim();
    this.getAccountList();
    this.SelectedAcnt =this.lstAccount.filter(t=>t.split('-')[0].trim()== this.Vowd.ObjectAccount.trim())[0];
    this.prevSelectedAcnt =this.lstAccount.filter(t=>t.split('-')[0].trim()== this.Vowd.ObjectAccount.trim())[0];
    this.MonthYear =this.Vowd.Period;
    this.DivisionField =this.Vowd.DivisionField;
    this.getCurrency();
    this.SelectedCur = this.Vowd.CurrencyType.trim();
    this.PreviousContractVOWDAmount = this.Vowd.ContractAmount;
    this.ContractVOWDAmount =this.Vowd.ContractAmount;
    this.DescriptionofWork = this.Vowd.DescrOfWork;
  }

  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
   
  }

  getExceptionSuppliers(SupplierID:string)
  {
    this.userService.getExceptionSuppliers(SupplierID).subscribe(data=>{
      this.exceptionSupplierResult = data;
    });
    
   
  }

  
  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  
  selectedItemSup(item:any){
    this.SupShortName=this.suppliersResult.filter(t=>t.SupplierAB ==item.item.split('-')[0])[0].SupplierShortName;
    this.getContractData(item.item.split('-')[0]);
    this.getExceptionSuppliers(item.item.split('-')[0]);
  }

  getCostCenterList()
  {
    this.lstCostCenter = this.gd.getCostCenterData();
    this.arrayListCostCntr = this.lstCostCenter.map(cost => cost.CostCenter.trim());
 
  }

  searchCostCenter = (text$: Observable<string>) =>
  
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListCostCntr.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
     
  )

  selectedItem(item:any){
    this.SelectedCC=item.item;
    this.getAccountList();
  }

  selectedObjAccount(item:any){    
    var ObjAccount = item.item.split("-")[0];
    
  }

  getAccountList()
  {
        this.userService.getAccountList(this.SelectedCC.trim()).subscribe(data=>{
        this.lstAccount = data;           
        this.getCurrency();
        this.CompanyCode = this.lstCostCenter.filter(t=>t.CostCenter.trim() ==this.SelectedCC.trim())[0].CompanyCode;
        this.DivisionField = this.lstCostCenter.filter(t=>t.CostCenter.trim() ==this.SelectedCC.trim())[0].CostCenterDesc;
        this.AreaModel = this.lstCostCenter.filter(t=>t.CostCenter.trim() ==this.SelectedCC.trim())[0].Area_CODE.trim()+"-"+this.lstCostCenter.filter(t=>t.CostCenter.trim() ==this.SelectedCC.trim())[0].Area_description ;
        this.DepartmentModel = this.lstCostCenter.filter(t=>t.CostCenter.trim() ==this.SelectedCC.trim())[0].Division;
        
        
        });
       
  }

  getContractData(SupplierID:string){
    this.userService.getContractData(SupplierID).subscribe(data=>{
      this.lstContract = data;     
      });
  }

  getObjectAccount()
  {
    this.lstAccount=this.gd.getAccountData();
   }

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.lstAccount.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchContract = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 1 ? []
      : this.lstContract.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  
  openAlertModal(strmsg:any) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }

  saveVowd()
  {
   
    if(!this.ValidateVOWDData()){
      this.openAlertModal("Please enter Valid Data");
      return;
    }
     if(parseInt(this.SupName.split('-')[0])==this.prevSupNo && this.SelectedAcnt==this.prevSelectedAcnt && this.SelectedCC ==this.prevSelectedCC && this.SelectedContract == this.prevSelectedContract)
     {
       this.SaveModal();
       return;
     }
     if(this.SelectedAcnt.split('-')[0]<=0)
     {
      this.openAlertModal("Please enter valid Object account");
      return;
     }
   
    
     if(this.ContractVOWDAmount<=0 )
     {
      this.openAlertModal("VoWD Amount should be a number greater than 0");
      return;
     }
     
    
      this.userService.checkVOWDDuplicateByContract(parseInt(this.SupName.split('-')[0]),this.SelectedAcnt.split('-')[0],this.SelectedCC,this.MonthYear,this.SelectedContract.split('-')[0]).subscribe(data=>{
        this.checkDuplicate =data;
        this.userService.CheckCostCenter(this.SelectedCC).subscribe(data =>{
          if(data.length < 0){
            this.openAlertModal("Please enter valid CostCenter");                        
            return;
          }
        });
       
        this.userService.CheckAccountObject(this.SelectedAcnt.split('-')[0]).subscribe(data=>{
           this.checkobjaccount=data;
       if(this.checkobjaccount==false)
          {
           
             this.openAlertModal("Please enter valid Object account"); 
             this.SelectedAcnt=null;           
            return;
          }
      else if(this.checkDuplicate >0 )
        {
          this.openAlertModal("Record already present for this combination");
          return;
        }
        else
        {
         this.SaveModal();
        }
      });
      },
      error=>{
       
      }
        ); 
  }
 
  SaveModal()
  {
   
    
    this.Vowd ={
      AccrualID :  this.Vowd ===null ?0: this.Vowd.AccrualID,
      SupplierAB : parseInt(this.SupName.split('-')[0]),//this.SupNo,
      CostCenter :this.SelectedCC,
      ContractId : (this.SelectedContract == 'undefined' || this.SelectedContract == 'null')  ?'':this.SelectedContract.trim(), 
      ContractDecscription : this.SelectedContract.substring(this.SelectedContract.indexOf('-')+1),
     
      ObjectAccount : this.SelectedAcnt.split('-')[0],
      Period : this.MonthYear,
      DivisionField : this.DivisionField,
      ContractAmount :this.ContractVOWDAmount ,
      ContractIdentity : this.ContractIdentity,
      DescrOfWork : this.DescriptionofWork,
       VOWDAmount: 0.00,
      CurrencyType : this.SelectedCur,
      IsActive : true,
      IsSave :true,
      IsSubmitted:false,
      MstCostCenter : null,
      MstSupplier : null,
      CreatedBy :   (this.Vowd !=null) ? this.Vowd.CreatedBy :  this.user.ProvisioningID, 
      CreatedDate : (this.Vowd !=null) ? this.Vowd.CreatedDate :  new Date(),  
      UpdatedBy :   (this.Vowd ==null) ? "" :  this.user.ProvisioningID, 
      UpdatedDate : (this.Vowd ==null) ? null :  new Date(),
      DueDate :  (this.Vowd ==null) ?  this.dueDate : this.Vowd.DueDate,
      OnBehalf : (this.Vowd ==null) ? this.BehalfCAI :this.Vowd.OnBehalf
    }
    this.activeModal.close(this.Vowd);
  }

  closeModal() {
    this.activeModal.dismiss(undefined);
  }

  initalCallService(){
      this.autoCompleteService.endPoint= environment.ApiUrl + "user/getsuplist/term";
    this.results = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(_ => (this.loading = true)),
      switchMap(term => this.autoCompleteService.search(term))
    );
    
  }

  
  
  
  

  // Push a search term into the observable stream.  
  searchCC(term: string): void {  
    this.loading = true;  
    this.searchTermsCC.next(term); 
  }  
   
  onselectCC(CCObj :CostCenter) {     
    if (CCObj.CostCenter != null) {  
      this.SelectedCC =CCObj.CostCenter;
      this.DivisionField = CCObj.CostCenterDesc;
      this.loading = false;  
      return true;
    }  
    else {  
      return false;  
    }
    this.getAccountList();  
  }

  
  
   // Push a search term into the observable stream.  
   searchObjAcnt(term: string): void {  
      this.loading = true;  
      this.searchTermsObj.next(term); 
  }  
  
 onselectObjAcnt(ObjAcnt :string) {     
   if (ObjAcnt != '') {  
    this.SelectedAcnt =ObjAcnt.split('-')[0].toString();
    this.ObjectAccountDesr =ObjAcnt;
    this.getCurrency();
     this.loading = false;  
     return true;
   }  
   else {  
     return false;  
   }
 }

  getCurrency()
  {
      this.userService.getCurrency().subscribe(data=>{
        this.lstCurrency = data;
    });
  }

  onSubmit() {
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.Vowd, null, 4));
  }

  getAllMstComp()
  {
    this.adminService.viewMstCompliance().subscribe(data=>{
      this.mstCompliances = data;
      if( this.mstCompliances  !=null){
       var d=  new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + this.mstCompliances[1].ToDate ;
       this.dueDate =new Date(d);
      }
    });
  }

  CheckUser(){
    if(this.exceptionSupplierResult != undefined){
      if(this.user.Role =="Admin" || this.exceptionSupplierResult.length > 0){
        return false;
      }else{
        return true;
      }   
    }else{
      if(this.user.Role =="Admin"){
        return false;
      }else{
        return true;
      }      
    }     
  }

  
  ValidateVOWDData() {
    if(this.lstAccount.indexOf(this.SelectedAcnt) <= -1){
     
      return false;
    }
    else if(this.arrayListCostCntr.indexOf(this.SelectedCC) <= -1){
    
      return false
    } //CostCenter    
    else if(this.arrayList.indexOf(this.SupName.trim()) <= -1){
      
      return false;
    } //Supplier
    else if(this.SelectedContract != "" && this.lstContract.indexOf(this.SelectedContract) <= -1){
      
      return false;
    }else{
      return true;
    }    
  }

  checkRemainingValue(){
    if(this.SelectedContract.toString() != "" ){
      this.userService.getRemainingAmount(this.SupName.split('-')[0],this.SelectedContract.split('-')[0]).subscribe(data=>{
        var remainingValue = data;
        if(this.ContractVOWDAmount > remainingValue[0]){
          this.openAlertModal("VOWD is greater than Remaining Contract Budget");
          return;
        }
      });
    }     
  
  }

  
}
